import TanStackTable from "root/TanstackTables/TanStackTable";
import SpinnerDiv from "ui/ReactSpinnerDiv";
import IconTooltip from "ui/Tooltip/IconTooltip";
import {ModalEditUserModes} from "root/s360components/Modals/UserEdit/useModalEditUser";


const UserEditTable = ({data, onClickEdit}) =>
{

    const isLoading = false;

    const actionFormatter = (info) =>
    {
        const row = info.row.original;

        return <div className="action-buttons">
            <IconTooltip icon='glyphicon-edit' placement='top' text="Edit Username" onClick={() => onClickEdit({mode: ModalEditUserModes.RENAME,
                enc_user_id: row.enc_user_id,
                user_type: row.user_type
            })}/>
        </div>
    }

    const columns = [
        {accessorKey: 'forename', header: 'Forename', enableSorting: true},
        {accessorKey: 'surname', header: 'Surname', enableSorting: true},
        {accessorKey: 'username', header: 'Username', enableSorting: true},
        {accessorKey: 'actions', header: 'Actions', enableSorting: false, meta: {textAlign: 'center'}, cell: actionFormatter}
    ];

    return (
        <div className='user-edit-table' key='userTable'>
            {isLoading === false && <TanStackTable data={data} columns={columns} showSearch={true}/>}
            {isLoading === true && <SpinnerDiv/>}
        </div>
    )
}

export default UserEditTable;